import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';

import UserLocation from '@/composables/useUserLocation';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { askUserLocation } = UserLocation();
onMounted(async () => {
  if (navigator) askUserLocation();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})